<template>
  <div id="blog">
    <blog-list v-if="!isMobile" id="blogMenu"
        :articles-list="articles.list"
        @selected="changeArticle"
    ></blog-list>

    <div v-else id="blog-header">
      <a id="logo" class="clickable flexwrap" href="https://www.learnandwatch.com"
                                     :style="{ backgroundImage: 'url(https://learnandwatch.s3.eu-west-3.amazonaws.com/logo2.webp)' }">
      </a>

      <div class="articles smallPaddingRound"
           @click="articlesListDisplay = !articlesListDisplay"><h1>Menu</h1></div>

    </div>

    <blog-list v-if="isMobile && articlesListDisplay" id="articlesList-mobile"
               :articles-list="articles.list"
               @selected="changeArticle"
    ></blog-list>
    <div id="blogArticle" class="lightplainTheme flexwrap">
        <h1>
          {{currentArticle.title}}
        </h1>
        <div v-html="currentArticle.body">
        </div>

    </div>
  </div>

</template>

<script>
import axios from "axios";
import {API_URL} from "@/App";
import BlogList from "@/components/blogList";
import {mapGetters} from 'vuex'

export default {
  name: "blog",

  components: {
    BlogList, closableCard: () => import(/* webpackPrefetch: true */ '@/components/closableCard.vue')
  },

  created() {
    this.fetchBlogData()
    // Si l'article est précisé, on va le chercher
    if (this.routeParams.articleId !== undefined) {
      this.articleInParam = true;
      this.fetchBlogArticle(this.routeParams.articleId)
    }

  },

  watch: {
    // Quand les articles sont chargés, on sélectionne le premier article si aucun n'a été spécifié dans l'url
    'articles.loaded': function () {
      if (this.articles.loaded && !this.articleInParam) {
        this.changeArticle(this.articles.list[0].id)
      }
    },
  },

  // quand un changement d'article est détecté dans l'url, on va chercher l'article correspondant
  beforeRouteUpdate(to, from, next){
    if(to.params.articleId !== from.params.articleId) {
      this.fetchBlogArticle(to.params.articleId)
    }
    next()
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'routeParams'
        ])
  },

  methods: {
    fetchBlogData() {
      let url = `${API_URL}/api/bloglist/`
      axios.get(url)
          .then(response => {
            return response.data;
          })
          .then(data => {
            this.articles.list = data
            this.articles.loaded = true
          })
    },

    fetchBlogArticle(articleId) {
      let url = `${API_URL}/api/blog/`
      axios.get(url + articleId + '/')
          .then(response => {
            return response.data;
          })
          .then(data => {
            this.currentArticle = data;
          });
    },

    changeArticle: function (id) {
      if(this.isMobile) {
        this.articlesListDisplay = !this.articlesListDisplay
      }
      this.$router.push({
        name: 'blog',
        params: {
          articleId: id
        }
      })
    },

  },

  data() {
    return {
      articleInParam: false,
      articles: {
        list: [],
        loaded: false
      },
      currentArticle: {},
      articlesListDisplay: false
    }
  }
}
</script>

<style scoped>
  #blog{
    width: available;
    height: 100%;
    display: grid;
    grid-template-columns: auto 1fr;
  }
  #blogMenu{
    width: max-content;
    max-width: 33%;
  }
  #blogArticle{
    width: calc( 100% - 40vw);
    max-width: calc( 100% - 40vw);
    height: calc(100% - 4vw);
    padding: 3vw 20vw 1vw 20vw;
    overflow: auto;
  }

  @media screen and (max-device-width: 767px) {
    #blog-header {
      position: relative;
      width: auto;
      height: 12vw;
      min-width: 100vw;
      max-width: 100vw;
      display: flex;
      justify-content: space-between;

      background-color: black;

      color: var(--goalBackgroundColor3);
      align-items: center;
      z-index: 20;
    }

    #logo {
      align-content: center;
      background-size: contain;
      background-repeat: no-repeat;

      height: 12vw;
      width: 20vw;
      margin: 1vw 2.5vw 1vw 2.5vw;
      background-position: center center;
    }

    #blog{
      width: available;
      height: 100%;
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: auto 1fr;
    }

    #blogMenu {
      max-width: 100vw;;
      width: 100vw;
      height: 10vh;
      background-color: black;
    }

    .articles {

    }

    #blogArticle{
      width: 100%;
      max-width: 100%;
      height: 100%;
      padding: 0px;
      overflow: auto;
    }

    #articlesList-mobile {
      position: absolute;
      width: 100vw;
      top: 12vw;
      left: 0px;
      height: calc(100vh - 12vw);
    }
  }


</style>